<template>
  <div>
    <p v-if="!outcomes.days.length" class="grey--text my-4">
      No parsing outcomes for the period
    </p>
    <template v-else>
      <h4 class="mt-2 mb-1">Total for {{ outcomes.daysCount }} days</h4>
      <v-simple-table dense>
        <tbody>
          <tr v-for="column in columns" :key="column.key">
            <td style="width: 140px" class="grey--text">
              {{ column.text }}
            </td>
            <td>
              <outcome-chips
                :items="cell(outcomes.totals, column)"
                :with-share="withShare && column.job !== 'method'"
              ></outcome-chips>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <h4 class="mt-6 mb-1">By day</h4>
      <v-data-table
        :headers="dayHeaders"
        :items="outcomes.days"
        item-key="date"
        :items-per-page="7"
        :footer-props="{ 'items-per-page-options': [7, 14, 30, -1] }"
        dense
        class="elevation-0"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-no-wrap">{{ item.date }}</td>
            <td v-for="column in columns" :key="column.key">
              <outcome-chips :items="cell(item, column)"></outcome-chips>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <p class="grey--text text-caption mt-2 mb-0">
      <span class="green--text">ok</span> &middot;
      <span class="orange--text">the site did not give the page</span>
      &middot;
      <span class="grey--text">our side (proxy, service)</span>
      &middot;
      <span class="red--text">page received, parsing failed</span>
      &middot;
      <span class="blue--text">download method decisions</span>
    </p>
  </div>
</template>

<script>
import OutcomeChips from "./OutcomeChips";

export const OUTCOME_COLUMNS = [
  { key: "linksFetch", text: "Links fetch", job: "links", stage: "fetch" },
  { key: "linksParse", text: "Links parse", job: "links", stage: "parse" },
  {
    key: "articlesFetch",
    text: "Articles fetch",
    job: "articles",
    stage: "fetch",
  },
  {
    key: "articlesParse",
    text: "Articles parse",
    job: "articles",
    stage: "parse",
  },
  { key: "method", text: "Download method", job: "method" },
];

export default {
  name: "OutcomesTables",
  components: { OutcomeChips },
  props: {
    // {daysCount, totals, days} of group_outcomes
    outcomes: { type: Object, required: true },
    // shares of the outcomes in the period totals
    withShare: { type: Boolean, default: false },
  },
  data() {
    return { columns: OUTCOME_COLUMNS };
  },
  computed: {
    dayHeaders() {
      return [{ text: "Date", value: "date", width: "110" }].concat(
        this.columns.map((column) => ({ text: column.text, value: column.key }))
      );
    },
  },
  methods: {
    cell(period, column) {
      if (column.job === "method") {
        return period.method || [];
      }
      return (period[column.job] || {})[column.stage] || [];
    },
  },
};
</script>
